import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const buildBillDefaultOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup => {
  const { translatedLabels } = context

  const options: MappingOption[] = [
    {
      label: translatedLabels.singularPrimaryOrgCategoryLabel,
      value: 'location',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.singularSecondaryOrgCategoryLabel,
      value: 'department',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.billUrlLabel,
      value: 'bill_url',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.billNotesLabel,
      value: 'bill_notes',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.poNumberLabel,
      value: 'purchase_order.number',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.itemDescriptionLabel,
      value: 'item_description',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.itemDescriptionAndPoNumberLabel,
      value: 'item_description_and_po_number',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.subsidiaryByLocationLabel,
      value: 'subsidiary_by_location',
      type: 'native',
      active: true,
    },
  ]

  return {
    options,
  }
}
